import { z } from 'zod';
import { isAfter, isFuture } from 'date-fns';

export const formSchema = z.object({
  deadlineDate: z.date().optional(),
  workedHours: z.number({ coerce: true }).optional(),
  personQuantity: z.number({ coerce: true }).optional(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  productsDeliveredAt: z.date().optional(),
}).superRefine((data, ctx) => {
  const { productsDeliveredAt, startDate, endDate } = data;

  if (productsDeliveredAt && isFuture(productsDeliveredAt)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['productsDeliveredAt'],
      message: 'Data de recebimento não pode ser futura',
    })
  }

  if (productsDeliveredAt && startDate && isAfter(productsDeliveredAt, startDate)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['startDate'],
      message: 'Data de início deve ser posterior a data de recebimento',
    })
  }

  if (startDate && isFuture(startDate)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['startDate'],
      message: 'Data de início não pode ser futura',
    })
  }

  if (endDate && !startDate) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['startDate'],
      message: 'Data de início é obrigatória se existe data de término',
    });
  }

  if (startDate && endDate && isAfter(startDate, endDate)) {
    return ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['endDate'],
      message: 'Data de término deve ser posterior a data de início',
    });
  }
});

export type FormSchema = z.infer<typeof formSchema>